import { Component } from '@angular/core';
import {ResponsiveService} from './services/responsive.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {
    title = 'app works!';

    constructor(public responsiveService: ResponsiveService,){
    }
}



// WEBPACK FOOTER //
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/app.component.ts